<template>
    <v-btn
        :class="className"
        :color="getButtonColor"
        :prepend-icon="icon"
        :variant="variant"
        :block="block"
        :size="size"
        :disabled="disabled"
        :loading="loading"
        :elevation="elevation"
        :border="border"
        :rounded="rounded"
        @click="handleClick"
    >
        <template v-if="!disabled">
            <slot />
        </template>
        <template v-else>
            {{ inactiveLabel }}
        </template>
    </v-btn>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ButtonVariant, TargetType } from '../types';
import { TARGET_TYPES } from '@/constants';

interface ButtonProps {
    color?: string;
    icon?: string;
    variant?: ButtonVariant;
    block?: boolean;
    size?: string;
    disabled?: boolean;
    loading?: boolean;
    elevation?: string | number;
    link?: string;
    target?: TargetType;
    inactiveLabel?: string;
    activeLabel?: string;
    border?: string;
    className?: string;
    rounded?: string;
}

const emit = defineEmits(['click']);

const props = withDefaults(defineProps<ButtonProps>(), {
    color: 'primary',
    icon: '',
    variant: 'outlined',
    block: false,
    size: 'default',
    disabled: false,
    border: 'sm',
    rounded: 'lg',
    loading: false,
    elevation: '0',
    link: '',
    target: TARGET_TYPES.BLANK,
    inactiveLabel: 'Button Disabled',
    activeLabel: 'Button Text',
    className: 'font-weight-bold'
});

const getButtonColor = computed(() => (props.disabled ? 'default' : props.color));

const handleClick = () => {
    emit('click');
    if (props.link) {
        window.open(props.link, props.target);
    }
};
</script>
